module.exports = __webpack_public_path__ + "bed-button-view-record.e7217a35.png";